// extracted by mini-css-extract-plugin
export default {"table_container":"keySkillsTable_table_container__3JP6b","table-row":"keySkillsTable_table-row__pHMT4"};